import { IconButton } from 'copilot-design-system';
import React from 'react';
import { InvoiceActionRendererProps } from 'src/legacy/components/AgGrid/Renderer/types';

const InvoiceActionRenderer = ({ data }: InvoiceActionRendererProps) => (
  <IconButton
    icon="ArrowRight"
    onClick={() => window.open(data.hosted_invoice_url, '_blank')}
    variant="minimal"
  />
);

export default InvoiceActionRenderer;
